import { createSelector } from '@reduxjs/toolkit';
import { isB } from 'core/window/bootstrapConfig';
import { ExperimentId } from 'core/type/ExperimentId';
import { selectConfigFromBootstrap, selectExperimentsFromBootstrap } from 'store/slice/bootstrap';
import {
    selectAvailabilityIsLoading,
    selectAvailabilityIsSearchCriteriaUpdated,
    selectAvailabilitySearchCriteriaStatus,
    selectIsOfferDateChipSelected,
    selectOfferSelected,
    selectSelectedBookingRequirement,
    selectTotalMaxPax,
    selectTotalPax,
    selectFinalOfferOption,
} from 'component/page/detail/store/availabilitySelectorIndex';
import { selectNumberOfAdults } from 'component/page/detail/CartCrossSellPanel/criteriaExtractor.selectors';
import { AvailabilitySearchCriteriaStatus } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardPaxPanel/PaxCounter/paxUtils';
import { BookButtonState } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/BookButtonContainer';

export const selectIsShowNotification = createSelector(
    selectAvailabilitySearchCriteriaStatus,
    selectIsOfferDateChipSelected,
    selectFinalOfferOption,
    selectExperimentsFromBootstrap,
    (searchCriteriaStatus, isOfferDateChipSelected, finalOfferOption, experiments) => {
        const isShowDateChipNotification = !isOfferDateChipSelected;
        const isShowOfferNotification = !finalOfferOption;
        const isMinPaxRequiredErrorMessage = [AvailabilitySearchCriteriaStatus.MinPaxRequired].includes(searchCriteriaStatus);
        const isACT_5551 = isB(ExperimentId.ACT_5551, experiments);
        return isShowDateChipNotification || isShowOfferNotification || (!isACT_5551 && isMinPaxRequiredErrorMessage);
    },
);

export const selectBookButtonState = createSelector(
    selectConfigFromBootstrap,
    selectAvailabilityIsLoading,
    selectSelectedBookingRequirement,
    selectNumberOfAdults,
    selectTotalPax,
    selectTotalMaxPax,
    selectAvailabilitySearchCriteriaStatus,
    selectAvailabilityIsSearchCriteriaUpdated,
    selectOfferSelected,
    selectIsShowNotification,
    (config, isLoading, selectedBookingRequirement, numberOfAdults, totalPax, totalMaxPax, searchCriteriaStatus, isSearchCriteriaUpdated, selectedOffer, isShowNotification) => {
        const isCheckAvailableQuantity = isB(ExperimentId.ACT_4598, config.experiments);
        const bookingRequirementMinPax = selectedBookingRequirement.minPax || 1;
        const isRequiredMinAdultsMet = !selectedBookingRequirement.adultRequired || numberOfAdults >= bookingRequirementMinPax;
        const isTotalExceedMaxPax = totalPax > totalMaxPax;
        const isMinPaxRequiredErrorMessage = [AvailabilitySearchCriteriaStatus.MinPaxRequired].includes(searchCriteriaStatus);
        const offer = selectedOffer.offer;
        const hasOnlyDisabledOptions = (offer?.enrichedOfferOption || []).filter((option) => option.isAvailable).length === 0;

        // Need to check isRequiredMinAdultsMet separately because errorMessage type will be overridden when max pax reached since we show another message
        const isButtonDisabled = isCheckAvailableQuantity
            ? !isRequiredMinAdultsMet || isTotalExceedMaxPax || isMinPaxRequiredErrorMessage || (!isSearchCriteriaUpdated && hasOnlyDisabledOptions)
            : isMinPaxRequiredErrorMessage || (!isSearchCriteriaUpdated && hasOnlyDisabledOptions);

        if (isLoading) {
            return BookButtonState.Loading;
        }
        return isButtonDisabled && !isShowNotification ? BookButtonState.Disabled : BookButtonState.Enabled;
    },
);
